import GuidLookupPagingResultModelBase from '../_generated/modelBases/guid-lookup-paging-result-model-base';

export default class GuidLookupPagingResultModel extends GuidLookupPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
